<template>
  <div class="c-table">
    <section class="operating">
      <div class="operatingLeft">
        <h1 v-if="typeof views === 'string'" class="cmsc-page-title theme-border-primary-color">{{ tableView }}</h1>
        <Dropdown v-else @on-click="tableViewChange">
          <h1 class="cmsc-page-title theme-border-primary-color">
            {{ tableView }}
            <Icon type="ios-arrow-down"></Icon>
          </h1>
          <DropdownMenu slot="list">
            <DropdownItem
              v-for="item in views"
              :name="item.value"
              :key="item.label"
              :selected="item.selected"
            >{{ item.label }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <slot name="operatingLeft"></slot>
      </div>
      <div class="operatingRight">
        <slot name="operatingRight"></slot>
      </div>
    </section>
    <div>
      <slot name="operatingBottom"></slot>
    </div>
    <div style = "position:relative;">
      <slot name="tableTop"></slot>
    </div>
    <Table ref = "_table" class="table" v-bind="$attrs" v-on="$listeners" >
      <!-- 视图 -->
      <template slot-scope="{ row, index }" slot="action">
        <span style="margin-right: 15px">
            <CIcon tip = "详情" :delay = "3000" icon="tongyong-chakan" handleColor = "default"  @click="viewObjectDetail(row)" size="16" style="cursor:pointer;"
                   v-if="(row.is_flow_type=='1' && viewCustomBtn) || (row.is_flow_type!='1' && viewCustomObj)"
                 class="icon_1"></CIcon>
        </span>
        <span style="margin-right: 15px">
            <CIcon icon="tongyong-bianji" tip = "编辑" :delay = "3000" hoverColor = "#04cbd8" activedColor = "#2b9da2" @click="editObjectDetail(row)" style="cursor:pointer;" size="16"
               v-if="(row.is_flow_type=='1' && editCustomBtn) || (row.is_flow_type!='1' && editCustomObj)"
               class="icon_1"></CIcon>
        </span>
        <span>
            <Poptip confirm transfer placement="right-end" title="确认删除该条数据吗？" @on-ok="deleteObjectDetail(row)">
              <CIcon icon="tongyong-shanchu" tip = "删除" :delay = "3000" handleColor = "delete" style="cursor:pointer" size="16"
                v-if="(row.is_flow_type=='1' && removeCustomBtn) || (row.is_flow_type!='1' && removeCustomObj)"
                class="icon_1"></CIcon>
            </Poptip>
        </span>
      </template>
      <!-- 流程 -->
      <template slot-scope="{ row, index }" slot="flowAction">
        <span  title="详情">
            <CIcon icon="tongyong-chakan"  tip = "详情" :delay = "3000" handleColor = "default"  @click="clickFlowRow(row)" size="16" style="cursor:pointer;"
                   v-if="(viewTypeId=='1'?(row.state_id=='1'?false:true):(viewTypeId=='2'?(row.state_id=='1'?false:false):(viewTypeId=='4' || viewTypeId=='3')?true:true))"
                   class="icon_1"></CIcon>
        </span>
        <span  title="编辑">
            <CIcon icon="tongyong-bianji"  tip = "编辑" :delay = "3000" handleColor = "default" @click="clickFlowRow(row)" style="cursor:pointer;" size="16"
                   v-if="(viewTypeId=='1'?(row.state_id=='1'?true:false):(viewTypeId=='2'?(row.state_id=='1'?true:false):(viewTypeId=='4' || viewTypeId=='3')?false:false))"
                   class="icon_1"></CIcon>
        </span>
        <span title="处理">
          <Icon type="md-checkmark-circle-outline"  tip = "处理" :delay = "3000" handleColor = "default" @click="clickFlowRow(row)" style="cursor:pointer" size="16"
                v-if="viewTypeId=='1'?(row.state_id=='1'?false:false):(viewTypeId=='2'?(row.state_id=='1'?false:true):(viewTypeId=='4' || viewTypeId=='3')?false:false)"
                class="icon_1" ></Icon>
        </span>
      </template>
    </Table>
    <Page class="page" v-bind="$attrs" v-on="$listeners" />
  </div>
</template>
<script>
export default {
  name: 'CTables',
  props: {
    views: [String, Array],
	  editCustomObj: {
    	 type : Boolean
      },
	  removeCustomObj: {
		  type : Boolean
	  },
	  viewCustomObj: {
		  type : Boolean
	  },
	  editCustomBtn: {
		  type : Boolean
	  },
	  removeCustomBtn: {
		  type : Boolean
	  },
	  viewCustomBtn: {
		  type : Boolean
	  },
	  viewTypeId: {
		  type : String
	  }
  },
  watch: {
    views: {
      handler(newValue) {
        if (typeof newValue === 'string') {
          this.tableView = newValue
          this.tableViewOptions = []
        } else {
          if (newValue.length > 0) {
            this.tableViewOptions = newValue
            for (let i = 0; i < this.tableViewOptions.length; i++) {
              if (this.tableViewOptions[i].selected) {
                this.tableView = this.tableViewOptions[i].label
                this.tableViewChange(this.tableViewOptions[i].value)
                return
              }
            }
          } else {
            this.tableView = ''
            this.tableViewOptions = []
          }
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      tableView: '',
      tableViewOptions: []
    }
  },
  methods: {
    selectAll(flag){
      this.$refs['_table']&&this.$refs['_table'].selectAll(flag)
    },
    tableViewChange(viewId) {
      this.tableViewOptions.forEach(item => {
        item.selected = false
      })
      let target = this.tableViewOptions.find(item => item.value === viewId)
      this.tableView = target.label
      target.selected = true
      this.$emit('on-view-change', target)
    },
    viewObjectDetail(row){
		this.$emit('viewObjectDetail', row)
    },
    editObjectDetail(row){
		this.$emit('editObjectDetail', row)
    },
    deleteObjectDetail(row){
		this.$emit('deleteObjectDetail', row)
    },
	  clickFlowRow(row){
		this.$emit('clickFlowRow', row)
    }
  }
}
</script>

<style lang="stylus">
.c-table
  .operating
    display flex
    justify-content space-between
    margin-bottom 30px

  .page
    margin-top 24px
    text-align center
</style>
